import { render, staticRenderFns } from "./upload-img.vue?vue&type=template&id=48e75418&scoped=true"
import script from "./upload-img.vue?vue&type=script&lang=ts"
export * from "./upload-img.vue?vue&type=script&lang=ts"
import style0 from "./upload-img.vue?vue&type=style&index=0&id=48e75418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e75418",
  null
  
)

export default component.exports